<template>
  <div class="d-flex flex-column align-items-center">
    <v-progress-circular indeterminate color="primary" />
    <div class="text-small mt-1">{{ message }}</div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  message: {
    type: String,
    default: () => "Loading..."
  }
});
</script>
